// extracted by mini-css-extract-plugin
module.exports = {"erpInformationLink":"Login_erpInformationLink__30Maw","loginErrorContainer":"Login_loginErrorContainer__2C5-v","login":"Login_login__1WBBY"};